// Tour Registry - All available tours
export { welcomeTour, dashboardTour, recordsTour, pfilesTour, workflowsTour, searchTour } from './institution';
export { platformWelcomeTour, mdaTour, configTour, analyticsTour } from './platform';

import type { Tour } from '../types';
import { welcomeTour, dashboardTour, recordsTour, pfilesTour, workflowsTour, searchTour } from './institution';
import { platformWelcomeTour, mdaTour, configTour, analyticsTour } from './platform';

// All institution tours
export const institutionTours: Tour[] = [
  welcomeTour,
  dashboardTour,
  recordsTour,
  pfilesTour,
  workflowsTour,
  searchTour,
];

// All platform tours
export const platformTours: Tour[] = [
  platformWelcomeTour,
  mdaTour,
  configTour,
  analyticsTour,
];

// All tours combined
export const allTours: Tour[] = [...institutionTours, ...platformTours];

// Tour registry for lookup
export const tourRegistry: Record<string, Tour> = {
  ...institutionTours.reduce((acc, tour) => ({ ...acc, [tour.id]: tour }), {}),
  ...platformTours.reduce((acc, tour) => ({ ...acc, [tour.id]: tour }), {}),
};

// Get tour by ID
export function getTourById(tourId: string): Tour | undefined {
  return tourRegistry[tourId];
}

// Get tours by category
export function getToursByCategory(category: 'institution' | 'platform' | 'common'): Tour[] {
  return allTours.filter(tour => tour.category === category);
}
